import React from 'react'
// components
import Address from './Address'
import Box from './Box'
import Breakpoints from './Breakpoints'
import Button from './Button'
import ButtonLink from './ButtonLink'
import Card from './Card'
import CodeBlock from './CodeBlock'
import ContactForm from './ContactForm'
import Flex from './Flex'
import Form from './Form'
import Grid from './Grid'
import Heading from './Heading'
import HorizontalCard from './HorizontalCard'
import Icon from './Icon'
import Image from './Image'
import ImageBox from './ImageBox'
import Input from './Input'
import Link from './Link'
import { UnorderedList } from './List'
import Map from './Map'
import ProfileCard from './ProfileCard'
import Section from './Section'
import Stack from './Stack'
import ServiceCard from './ServiceCard'
import Text from './Text'
import USP from './USP'
import VerticalCard from './VerticalCard'
import SEO from './SEO'
import StructuredData from './StructuredData'
import { withImages } from '../withImages'
import Parallax from './Parallax'

const gmApiKey = 'AIzaSyBrxypH1Y15U2e-Er3UfqWnNSL_76IaqWo'

const shortcodes = {
  Address,
  Box,
  Breakpoints,
  Button,
  ButtonLink,
  Card: withImages(Card, [{ key: 'img' }]),
  ContactForm,
  Flex,
  Form,
  Grid,
  Heading,
  HorizontalCard: withImages(HorizontalCard, [{ key: 'img' }]),
  Icon,
  Image: withImages(Image, [{ key: 'src' }]),
  ImageBox: withImages(ImageBox, [{ key: 'img', target: 'publicURL' }]),
  Input,
  Link,
  SEO,
  StructuredData,
  Parallax,
  Map: ({ height = 320, ...props }) => (
    <Map
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${gmApiKey}`}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height, overflow: 'hidden' }} />}
      mapElement={<div style={{ height: `100%` }} />}
      {...props}
    />
  ),
  Profile: withImages(ProfileCard, [{ key: 'img', target: 'publicURL' }]),
  Section: withImages(Section, [
    { key: 'headerImage', fluid: true },
    { key: 'bgImage', fluid: false },
  ]),
  ServiceCard,
  Stack,
  Text,
  USP,
  VerticalCard: withImages(VerticalCard, [{ key: 'img' }]),
  // https://mdxjs.com/getting-started/#mdxprovider
  a: Link,
  h1: props => <Heading as="h1" {...props} />,
  h2: props => <Heading as="h2" {...props} />,
  h3: props => <Heading as="h3" {...props} />,
  h4: props => <Heading as="h3" {...props} />,
  h5: props => <Heading as="h4" {...props} />,
  h6: props => <Heading as="h5" {...props} />,
  p: props => (
    <Text
      variant="body1"
      color="grey.main"
      css={{ marginBottom: '2em' }}
      {...props}
    />
  ),
  pre: props => (
    <pre {...props} style={{ margin: 0, whiteSpace: 'pre-line' }} />
  ),
  ul: UnorderedList,
  code: CodeBlock,
}

export default shortcodes
